import { useState } from "react";
import Logo from "../img/Logo_signcast_big-1080x322.png";
import { Link, useNavigate } from "react-router-dom";
import useAuthStore from "../store/authStore"; // Import auth store

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { login, isLoading, error, clearError } = useAuthStore();
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        clearError(); // Clear any previous errors
        // Basic validation
        if (!email || !password) {
          return;
        }
        
        const success = await login(email, password);
        
        // Navigate to dashboard if login is successful
        if (success) {
          navigate('/dashboard');
        }
      };

  return (
    <div className="login-container bg-blue-50 w-full h-screen flex justify-center items-center">
      <div className="bg-white w-[420px] h-[480px] rounded-lg shadow-lg">
        <div className="flex flex-row justify-center pt-10">
          <img className="w-52 h-auto" src={Logo} alt="Logo" />
        </div>
        
        <form onSubmit={handleLogin}>
          {error && (
            <p className="text-red-500 text-[14px] text-center mt-2">{error}</p>
          )}
          
          <div className="flex flex-col pl-10">
            <p className="text-black text-[14px] pt-6 pb-2">
              Enter your email address
            </p>
            <input
              className="text-[14px] pl-4 w-[340px] h-[45px] rounded-lg border-2 border-gray-300"
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="flex flex-col pl-10">
            <p className="text-black text-[13px] pt-6 pb-2">
              Enter your password
            </p>
            <input
              className="text-[14px] pl-4 w-[340px] h-[45px] rounded-lg border-2 border-gray-300"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <p className="text-gray-500 text-[14px] pt-2">
              Don't have an account?{" "}
              <Link 
                to="/signup"
                style={{ textDecoration: 'none' }}
              >
                Sign up
              </Link>
            </p>
            <p className="text-gray-500 text-[14px] pt-1">
              <Link 
                to="/forgot-password"
                style={{ textDecoration: 'none' }}
              >
                Forgot Password?
              </Link>
            </p>
          </div>
          
          <div className="flex flex-col pt-8 p-10 rounded-lg">
            <button
              type="submit"
              disabled={isLoading}
              className="h-[41px] w-full bg-blue-500 text-white text-[14px] font-bold rounded-lg hover:bg-blue-600 transition-colors"
            >
              {isLoading ? "Signing in..." : "Sign in"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
